import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  BookKeepingStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';

export const fields: IBaseField<keyof BookKeepingStateValues>[] = [
  {
    name: 'didYouHaveAProfessionalAtAccountantsOnAirPrepareFinancialStatementsForYourBusiness',
    label:
      'Did you have a professional at Accountants on Air prepare financial statements for your business?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'congratulationsThatMeansMuchLessWorkForYouOnThisTaxInformationweWillImportYourFinancialStatementsDirectlyFromOurBookkeepingSoftware',
        label: () =>
          'Congratulations! That means much less work for you on this tax information!\nWe will import your financial statements directly from our bookkeeping software.',
        type: 'information',
        effect: updateKeyInStore(updateKey),
        comment: true,
        predicate: (v) => v === 'yes',
      },
      {
        name: 'didYouKnowWeOfferBookkeepingFinancialStatementPreparationServicesifInterestedPleaseAskYourTaxAdvisorForMoreDetails',
        label:
          'Did you know we offer bookkeeping / financial statement preparation services?\nIf interested, please ask your tax advisor for more details',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'no',
        comment: true,
        dependencies: [
          {
            type: 'information',
            predicate: (v) => v === 'yes',
            label: () => (
              <a
                target="_blank"
                href="https://app.acuityscheduling.com/schedule.php?owner=14032819"
                className="text-green font-semibold hover:underline"
                rel="noreferrer"
              >
                Speak to a specialist right now
              </a>
            ),
          },
        ],
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
